<template>
  <div class="content ht-100v pd-0">
    <div ref="mainHeader" class="content-header bd-b pd-0">
      <nav class="navbar navbar-expand-lg wd-100p" style="height: 59px;">
        <a
          class="navbar-brand tx-spacing--2 order-1"
          data-toggle="dropdown"
          role="button"
        >
          {{ modTitle }}
        </a>
      </nav>
    </div>

    <div class="content-body pd-x-0 pd-y-0 overflow-hidden">
      <div class="container-fluid pd-x-0">
        <div class="row no-gutters">
          <div class="col-xs-3 col-md-3 bg-white">
            
            <div class="overflow-auto" style="height: calc(100vh - 60px)">
              <div v-for="(k, i) in keys" :key="i">
                <div
                  @click="loadKey(k)"
                  :class="
                    `d-flex align-items-center bd-b pd-5 tx-12 bg-${
                      keyCur.id == k.id ? 'white' : 'gray-100'
                    }`
                  "
                  role="button"
                >
                  
                  <feather
                    :type="`${keyCur.id == k.id ? 'arrow-down' : 'folder'}`"
                    class="mg-r-5" style="width: 15px !important; height: 15px !important"
                  >
                    
                  </feather>
                  
                  <div class="d-flex">
                    <div class="text-truncate">
                      {{ k.title }} 
                    </div>
                    <sup class="badge">{{ k.count.toLocaleString()}}</sup>
                  </div>
                  
                  <button
                    @click.stop="showAddEditMdl(1, 0)"
                    type="button"
                    class="mg-l-auto btn btn-xs btn-primary"
                    style="padding: 0px 3px"
                  >
                    <feather type="plus" style="width: 12px !important; height: 12px !important"></feather>
                    <!-- Шинэ -->
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-9 col-md-9 bd-l">
            <div class="d-flex flex-row">
              <div class="wd-40p" style="height: calc(100vh - 60px); overflow: auto">
                <div class="pd-5 d-flex align-items-center">
                  <div class="wd-100p pd-r-10">
                    <input v-if="keyCur.id > 0" placeholder="Хайх" v-model="filterText" class="form-control wd-100p" />
                  </div>
                  <div class="btn-group mg-l-auto">
                    <a @click="$refs.folterTree.filter(filterText)" class="btn btn-primary btn-xs" role="button">Хайх</a>
                    <a @click="filterText=''; treeKey++" class="btn btn-light btn-xs" role="button">Бүгд</a>
                  </div>
                </div>
                <div style="height: calc(100vh - 120px); overflow: auto">
                  <Tree v-if="keyCur.id > 0"
                    ref="folterTree"
                    node-key="id"
                    node-key1="label"
                    
                    @node-click="treeItemClick"
                    :data="casData"
                    :props="defaultProps"
                    :default-expand-all="(keyCur.count != undefined && keyCur.count >1000) ? false : true "
                    highlight-current
                    :filter-node-method="filterNode"
                    :key="treeKey" 
                    auto-expand-parent
                    accordion
                    :expand-on-click-node="true" >

                    <span class="custom-tree-node" slot-scope="{ node, data }">
                    <div
                      class="text-truncate tx-12"
                      style="max-width: 200px"
                      :title="node.label"
                    >
                      {{ node.label }}
                    </div>
                    <div class="btn-group btn-xs">
                      <button
                        class="btn btn-xs btn-icon tx-thin"
                        @click.stop="append(data)"
                      >
                        <feather
                          type="git-merge"
                          class="wd-15-f ht-15-f"
                        ></feather>
                      </button>
                      <button
                        class="btn btn-xs btn-icon"
                        @click.stop="() => edit(data)"
                      >
                        <feather type="edit" class="wd-15-f ht-15-f"></feather>
                      </button>
                      <button
                        class="btn btn-xs btn-icon"
                        @click.stop="() => remove(node, data)"
                      >
                        <feather
                          type="trash-2"
                          class="wd-15-f ht-15-f"
                        ></feather>
                      </button>
                    </div>
                  </span>

                  </Tree>
                </div>
              </div>
              <div v-if="rightMode == 0"></div>
              <div
                v-else-if="rightMode == 1"
                class="container overflow-auto bg-gray-200"
                style="height: calc(100vh - 60px); overflow: auto"
              >
                <div class="row justify-content-center no-gutters">
                  <div class="col-10 col-sm-6 d-flex flex-column bg-white bd ">
                    <form class="pd-10">
                      <div class="form-group">
                        <label for="formGroupExampleInput" class="d-block"
                          >Парент</label
                        >
                        

                        <Cascader 
                          style="width: 100%"
                          :options="locTypesCascader"
                          :props="cscdrProps"
                          v-model="cascaderSelected"
                          @change="cascaderOnChange"
                          change-on-select
                        ></Cascader>
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block">{{ fObj.name }}</label>
                        <input
                          v-model="locTypeModel.name"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.value }}</label
                        >
                        <input
                          v-model="locTypeModel.value"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >Код</label
                        >
                        <input
                          v-model="locTypeModel.code"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <!-- <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >Төлбөр</label
                        >
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >Төлбөр</label
                        >
                      </div> -->
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.field1 }}</label
                        >
                        <input
                          v-model="locTypeModel.field1"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.field2 }}</label
                        >
                        <input
                          v-model="locTypeModel.field2"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.field3 }}</label
                        >
                        <input
                          v-model="locTypeModel.field3"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.field4 }}</label
                        >
                        <input
                          v-model="locTypeModel.field4"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >{{ fObj.field5 }}</label
                        >
                        <input
                          v-model="locTypeModel.field5"
                          type="text"
                          class="form-control"
                        />
                      </div>
                      
                      <!-- <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >Дараалал</label
                        >
                      </div>
                      <div class="form-group">
                        <label for="formGroupExampleInput2" class="d-block"
                          >Хавсралт</label
                        >
                      </div> -->
                      <!-- <button class="btn btn-primary" type="submit">Submit</button>
                        <button class="btn btn-secondary" type="cancel">Cancel</button> -->
                    </form>
                    <div class="d-flex mg-b-5 bd-t pd-10 bg-gray-100">
                      <div class="d-flex">
                        <!-- <button class="btn btn-xs pd-x-15 btn-white btn-uppercase mg-l-5">
                            <feather type="trash-2"></feather>
                            Устгах
                          </button>
                          <button class="btn btn-xs pd-x-15 btn-white btn-uppercase mg-l-5">
                            <feather type="edit"></feather>
                            Засах
                          </button> -->
                        <button
                          @click="saveLocType()"
                          class="btn btn-xs pd-x-15 btn-primary btn-uppercase"
                        >
                          <feather type="plus"></feather>
                          Хадгалах
                        </button>
                      </div>
                      <div class="mg-l-auto">
                        <button
                          @click="showAddEditMdl(0)"
                          class="btn btn-xs pd-x-15 btn-danger btn-uppercase mg-l-5"
                        >
                          <feather type="x"></feather>
                          Болих
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="rightMode == 2" class="wd-60p bg-gray-100" style="height: calc(100vh - 60px); overflow: auto">
                <h4 class="mg-b-0 tx-spacing--1">Шинж чанар</h4>
                <div class="wd-100p">
                  <div class="wd-100p mg-b-20">
                    <ul v-if="fields.length > 0" class="list-group">
                      <!-- {{valueModel.propertyId}} -->
                      <li
                        class="list-group-item"
                        v-for="(f, i) in fields"
                        :key="i"
                        :class="{
                          'bg-light': valueModel.propertyId == f.property.id
                        }"
                      >
                        <div @click="initValue(f)" role="button" class="d-flex">
                          {{ i + 1 }}. {{ f.property.title }}
                          <!-- {{f.property.id}} -->
                          <div class="mg-l-auto">
                            <feather
                              :type="
                                valueModel.propertyId == f.property.id
                                  ? 'chevron-up'
                                  : 'chevron-down'
                              "
                            ></feather>
                          </div>
                        </div>

                        <div
                          v-show="valueModel.propertyId == f.property.id"
                          :class="`bg-light bd`"
                        >
                          <div class="d-flex pd-10 bg-white">
                            <div class="wd-60p">
                              Утга
                              <input
                                class="form-control wd-100p"
                                v-model="valueModel.value"
                              />
                            </div>
                            <div class="mg-l-auto d-flex align-items-end">
                              <div class="wd-100">
                                Эрэмбэ
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="valueModel.ord"
                                />
                              </div>
                              <div>
                                <button
                                  @click="postValue"
                                  class="btn btn-xs pd-x-15 btn-outline-success btn-uppercase mg-l-10"
                                >
                                  <feather type="plus"></feather>
                                  Хадгалах
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            v-for="(v, vi) in f.property.values"
                            :key="vi"
                            :class="
                              `d-flex pd-5 ${
                                vi < f.property.values.length - 1 ? 'bd-b' : ''
                              } tx-12 bg-gray-200`
                            "
                          >
                            {{ v.value }}
                            <div class="mg-l-auto d-flex">
                              <div
                                @click="valueModel = v"
                                role="button"
                                class="mg-r-5"
                              >
                                <feather
                                  type="edit"
                                  class="wd-15-f ht-15-f"
                                ></feather>
                              </div>
                              <div
                                @click="
                                  valueModel = v;
                                  valueModel.isDeleted = true;
                                  postValue();
                                "
                                role="button"
                              >
                                <feather
                                  type="trash-2"
                                  class="wd-15-f ht-15-f"
                                ></feather>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div v-else>Мэдээлэл хоосон байна</div>
                  </div>
                  <div class="wd-100p">
                    <form class="pd-10 pd-t-0-f">
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label">Гарчиг</label>
                        <div class="col-sm-10 pd-t-0-f">
                          <input
                            class="form-control"
                            v-model="fieldModel.property.title"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label">Эрэмбэ</label>
                        <div class="col-sm-10 pd-t-0-f">
                          <input
                            class="form-control"
                            v-model="fieldModel.editOrd"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label"
                          >Хэмжих нэгж</label
                        >
                        <div class="col-sm-10 pd-t-0-f">
                          <input
                            class="form-control"
                            v-model="fieldModel.property.measure"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label">Санамж</label>
                        <div class="col-sm-10 pd-t-0-f">
                          <input
                            class="form-control"
                            v-model="fieldModel.property.info"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label">Компонент</label>
                        <div class="col-sm-10 pd-t-0-f">
                          <Select
                            @change="componentOnChange"
                            v-model="fieldModel.property.type"
                            class="wd-100p"
                          >
                            <Option
                              :value="c.id"
                              :label="c.title"
                              v-for="(c, i) in comps"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-2 col-form-label">Бүтэц</label>
                        <div class="col-sm-10 pd-t-0-f">
                          <Select
                            v-model="fieldModel.property.struct"
                            :disabled="fieldModel.property.type == 4"
                            class="wd-100p"
                          >
                            <Option
                              :value="s.id"
                              :label="s.title"
                              v-for="(s, i) in structs"
                              :key="i"
                            ></Option>
                          </Select>
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-4 col-form-label"
                          >Заавал бөглөх ?</label
                        >
                        <div class="col-sm-8 pd-t-0-f">
                          <input
                            type="checkbox"
                            v-model="fieldModel.property.required"
                          />
                        </div>
                      </div>
                      <div
                        class="form-group row mg-b-0-f"
                        v-show="fieldModel.property.required"
                      >
                        <label class="col-sm-4 col-form-label"
                          >Бөглөөгүй бол өгөх сануулга</label
                        >
                        <div class="col-sm-8 pd-t-0-f">
                          <input
                            class="form-control"
                            v-model="fieldModel.property.requiredText"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-4 col-form-label"
                          >Хайлтад харуулах ?</label
                        >
                        <div class="col-sm-8 pd-t-0-f">
                          <input
                            type="checkbox"
                            v-model="fieldModel.property.filter"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-4 col-form-label"
                          >Жагсаалтад харуулах ?</label
                        >
                        <div class="col-sm-8 pd-t-0-f">
                          <input
                            type="checkbox"
                            v-model="fieldModel.property.showClient"
                          />
                        </div>
                      </div>
                      <div class="form-group row mg-b-0-f">
                        <label class="col-sm-4 col-form-label">Устгах ?</label>
                        <div class="col-sm-8 pd-t-0-f">
                          <input
                            type="checkbox"
                            v-model="fieldModel.isDeleted"
                          />
                        </div>
                      </div>
                    </form>
                    <div class="d-flex mg-b-5 bd-t pd-10 bg-gray-100">
                      <div class="d-flex">
                        <button
                          @click="saveField()"
                          class="btn btn-xs pd-x-15 btn-primary btn-uppercase"
                        >
                          <feather type="plus"></feather>
                          Хадгалах
                        </button>
                      </div>
                      <div class="mg-l-auto">
                        <button
                          @click="initField(locTypeModel.id, 0)"
                          class="btn btn-xs pd-x-15 btn-danger btn-uppercase mg-l-5"
                        >
                          <feather type="x"></feather>
                          Болих
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="dataCreate.modal">
      {{ keyCur }}
    </b-modal>
  </div>
</template>

<script>
import {
  Tree,
  CascaderPanel,
  Cascader,
  Button,
  Form,
  FormItem,
  MessageBox,
  Select,
  Option
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
var LTT = require("list-to-tree");
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import { mapActions } from "vuex";


export default {
  components: {
    Tree,
    CascaderPanel,
    Cascader,
    Button,
    Form,
    FormItem,
    MessageBox,
    Select,
    Option
  },
  data() {
    return {
      fObj:{
        name: 'Нэр',
        value: 'Утга',
        field1: 'Field 1',
        field2: 'Field 2',
        field3: 'Field 3',
        field4: 'Field 4',
        field5: 'Field 5',
      },

      

      filterText: "",
      formKey: 0,
      locTypeModel: {
        id: null,
        chiefUserId: null,
        timesheetUserId: null
      },
      departsFlat: [],
      departs: [],
      defaultProps: {
        children: "children",
        label: "label",
        iid: "id"
        // children: "ch",
        // label: "t",
        // iid: "i"
      },
      cscdrProps:{
        // value: 'i',
        // label: 't',
        // children: "ch",

        value: "value",
        label: "label",
        children: "children",
        // multiple: true,
      },
      temp_cscdrProps:{
        value: 'i',
        label: 't',
        children: "ch",
        // value: "value",
        // label: "label",
        // children: "children",
      },
      treeKey: 0,
      expandKeys: [],
      keys: [],
      keyCur: {
        id: null
      },
      casData: [],
      casDataFlat: [],
      dataCreate: {
        modal: false
      },
      curLocId: null,

      rightMode: 0,
      cascaderSelected: [],
      locTypesCascader: [],

      temp_locTypesCascader:[
        
  {
    // i: 'zhinan',
    i: 1,
    t: 'aimag',
    ch: [
      {
        i: 2,
        t: 'bulgan',
        ch: null
        // ch: [
        //   { i: 3, t: 'teshig' }
        // ]
      }
    ]
  }



  // {
  //   i: 1,
  //   t: 'ub',
  //   ch: [
  //     {
  //       i: 2,
  //       t: 'bgd',
  //       ch: [
  //         { i: 3, t: 'horoo1' },
  //         { i: 4, t: 'horoo2' }
  //       ]
  //     }
  //   ]
  // }
],
    temp_cascaderSelected: [],
    // temp_cascaderSelected: ['zhinan', 'shejiyuanze', 'yizhi'],

      cascaderSelectedKey: 0,

      locTypekey: "",

      structs: [],
      comps: [],
      fields: [],
      valueModel: {},
      fieldModel: {
        property: {}
      },

      modTitle: 'Лавлах сан'
    };
  },
  mounted() {
    //this.init();
    this.getStructs();
    
  },
  // watch: {
  //   filterText(val) {
  //     if(val!=undefined && val!=null && val.length>2)
  //       this.$refs.folterTree.filter(val);
  //   }
  // },
  methods: {
    ...mapActions(["handleLoading", "handleAside", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      //console.log('toggleBodyClass fired');
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getStructs() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Ltdb/GetStructs" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.structs = res.data.structs;

          this.getComponents();
        }
      });
    },
    getComponents() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Ltdb/GetComponents" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res.data', res.data);
          this.comps = res.data.components;

          this.init();
        }
      });
    },
    initValue(m) {
      //console.log('initValue', m);
      this.fieldModel = m;

      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Ltdb/GetNewValueModel" },
        params: { propertyId: m.property.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.valueModel = res.data.value;
          //console.log('valueModel res', this.valueModel);
          //this.initField(this.locTypeModel.id, m.property.id);
        }
      });
    },
    initField(lid, pid) {
      //console.log('initField=> ', this.locTypeModel, lid, pid);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Ltdb/GetFieldModel" },
        params: { locTypeId: lid, propertyId: pid != undefined ? pid : 0 },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('fieldModel=> ', res.data.fieldModel);
          this.fieldModel = res.data.fieldModel;
        }
      });
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Type/keyInGroup" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('res=>', res.data.keys);
          this.keys = res.data.keys;
          this.initAfter();
          //   var ltt = new LTT(res.data.keys, {
          //       key_id: "id",
          //       key_parent: "parentId",
          //       key_child: "children",
          //       key_ord: "ord"
          //   });
          //   this.departs= ltt.GetTree();

          // this.keyCur = { id: 1218 };
          // this.loadKey(this.keyCur);
        }
      });
    },
    initAfter(){
      if(this.$store.state.app.activeGroup.id==9298){
        if(hasOneOf(['toli.ac.mn'], this.$store.state.app.activeGroup.hostPro)){
          this.keys = this.keys.filter(x=>x.key=='sc_db_keywords');
          if(this.keys.length) {
            // console.log('this.keys.length', this.keys.length);
            this.modTitle= this.$store.state.app.activeGroup.name;
            let _obj = this.$store.state.app.mainLayoutConfig;
              _obj.aside = false;
              _obj.header = 22;
              _obj.footer = false;
              this.handleMainLayoutConfig(_obj);

            this.keyCur = { id: null };
            this.loadKey(this.keys[0]);

            this.fObj.name= 'Монгол нэр';
            this.fObj.value= 'Тодорхойлолт монгол';
            this.fObj.field1= 'Англи нэр';
            this.fObj.field2= 'Эх сурвалж';
            this.fObj.field3= 'Хам сэдэв';
            this.fObj.field4= 'Тодорхойлолт англи';
            this.fObj.field5= 'Нэр /Монгол бичиг/';
          }
        }
      } else 
      //if(this.$store.state.app.activeGroup.id==9241 || this.$store.state.app.activeGroup.id==9249)
      {
        //console.log('keyCur', this.keyCur);
        // this.keys = this.keys.filter(x=>x.key=='lmsVidTips');
        if(this.keyCur.key=='lmsVidTips') {
          this.fObj.name= 'Видео гарчиг';
          this.fObj.value= 'Youtube URL';
        }else{
          this.fObj.name= 'Нэр';
          this.fObj.value= 'Утга';
        }
      }
    },
    // departChange(e){
    //     this.toggleBodyClass("addClass", "dynamic-locker");
    //     request({
    //         api: { method: "GET", url: "Hr/GetInheritedDepart" },
    //         params:{id: e.id},
    //         store: this.$store
    //     }).then(res => {
    //         this.toggleBodyClass("removeClass", "dynamic-locker");
    //         if (res != false) {
    //         this.locTypeModel = res.data.depart;
    //         this.formKey++;
    //         //console.log(e);
    //         }
    //     })
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data.t.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    },
    showAddEditMdl(mode, id, pid) {
      if (mode != undefined) {
        //console.log('mode', mode, id);
        if (mode == 1) {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "Type/GetInheritedDetail" },
            params: {
              id: id,
              parentId: pid != undefined ? pid : 0,
              key: this.keyCur.key
            },
            store: this.$store
          }).then(res => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              // console.log('Type/GetInheritedDetail=> ', res.data , res.data.parentId);
              this.locTypeModel = res.data;

              this.cascaderSelected = [];
              if (res.data.parentId > 0) {
                // console.log('stp 1');
                // this.cascaderSelected.push(id);
                this.cascaderModelRecursive(
                  this.casDataFlat,
                  res.data.parentId
                );
                this.cascaderSelected = this.cascaderSelected.reverse();
                this.temp_cascaderSelected= [1,2];
              } else this.cascaderSelected = [];

              
              // console.log('cascaderSelected', this.cascaderSelected)
            }
          });
        } else if (mode == 2) {
          // console.log('stp 2');
          this.locTypeModel.id = id;
        }
        this.rightMode = mode;
      }

      //this.dataCreate.modal= true;
    },
    cascaderModelRecursive(data, cid) {
      this.cascaderSelected.push(cid);
      let pid = data.filter((d) => d.i == cid)[0].p;
      if (pid > 0) {
        //console.log('pid olsnu', pid);
        this.cascaderModelRecursive(data, pid);
      }
    },

    loadKey(k, afterAff) {
      //console.log('ld key ', k);
      if (this.keyCur.id == k.id) {
        this.keyCur = {
          id: null
        };
        this.rightMode = 0;
      } else {
        this.toggleBodyClass("addClass", "dynamic-locker");
        this.treeKey++;
        this.casData= [];
        this.rightMode = 2;
        // this.toggleBodyClass("addClass", "dynamic-locker");
        // request({
        //   api: { method: "GET", url: "Type/keyInGroupDetail" },
        //   params: { id: k.id },
        //   store: this.$store
        // }).then(res => {
        //   this.toggleBodyClass("removeClass", "dynamic-locker");
        //   if (res != false) {
        //     //console.log(res);
        //     // if(afterAff!=undefined && afterAff){
        //     //   this.showAddEditMdl();
        //     // }
        //   }
        // });

        
        request({
          //api: { method: "GET", url: "Type/getTreeDataWithTitle" },
          // api: { method: "GET", url: "Type/GetAsyncTreeData" },
          api: { method: "GET", url: "Type/GetAsyncTreeDataFullname" },
          params: { 
            key: k.key,
            // flat: true
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            // console.log('Type/GetAsyncTreeData', res.data.flat);
            // res.data.types = res.data.types.map(e =>
            //   Object.assign(e, { t: e.cc > 0 ? `(${e.cc}) - ${e.t}` : e.t })
            // );
            this.casDataFlat = res.data.flat;
            // this.casDataFlat = res.data.flatData;
            // this.casDataFlat = res.data.types;

            // var ltt = new LTT(res.data.types, {
            //   key_id: "id",
            //   key_parent: "parentId",
            //   key_child: "children",
            //   key_ord: "ord"
            // });

            //this.casData = ltt.GetTree();
            this.casData= res.data.types
            //this.locTypesCascader = ltt.GetTree();
            this.locTypesCascader = this.casData;
            //console.log(this.casData);

            this.keyCur = k;
            this.treeKey++;

            // this.initAfter();
          }
        });
      }
    },
    cascaderPanelChanged(e) {
      //console.log('step 1');
      //console.log('cascaderPanelChanged', e);
      this.cascaderPanelSelect(e);
    },
    cascaderPanelBlured(e) {
      //console.log('step 2');
      //console.log('cascaderPanelBlured', e);
      this.cascaderPanelSelect(e);
    },
    cascaderPanelSelect(e) {
      if (e.length > 0) {
        //console.log('step 3');
        //this.curLocId= e.pop();
      } else {
        //console.log('step 4');
        //this.curLocId= e;
      }

      //console.log('this.curLocId', this.curLocId);
    },
    append(data) {
      // console.log('data=> ', data);
      //this.showAddEditMdl(1, 0, data.id);
      // if(data.id!=undefined){
      //   this.showAddEditMdl(1, data.id);  
      // }else{
      //   this.showAddEditMdl(1, data.i);  
      // }
      if(data.value!=undefined){
        this.showAddEditMdl(1, 0, data.value);  
      }else{
        this.showAddEditMdl(1, data.i);  
      }
    },
    edit(e) {
      //console.log('data=> ', e);
      // if(e.i!=undefined){
      //   this.showAddEditMdl(1, e.i);  
      // }else{
      //   this.showAddEditMdl(1, e.id);  
      // }
      if(e.i!=undefined){
        this.showAddEditMdl(1, e.i);  
      }else{
        this.showAddEditMdl(1, e.value);  
      }
    },
    remove(e) {
      let self = this;
      // console.log('remove=> ', e);
      let _id=0;
      // console.log('e data', e.data)
      if(e.data!=undefined){
        // console.log('e.Node.data.value', e.data.value);
        _id= e.data.value;
      }
      // if(e.Node!=undefined && e.Node.id!=undefined){
      //   _id= e.Node.id;
      //  }else if(e.data!=undefined && e.data.i!=undefined){
      //   _id= e.data.i;
      // } else if(e.data!=undefined && e.data.id!=undefined){
      //   _id= e.data.id;
      // }

      MessageBox.confirm(
        e.data.label + "-г устгахдаа итгэлтэй байна уу",
        "Мэдэгдэл",
        {
          confirmButtonText: "Тийм",
          cancelButtonText: "Үгүй",
          callback: action => {
            if (action == "cancel") {
              //console.log('step 1');
            } else if (action == "confirm") {
              self.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "POST", url: "Type/deleteType" },
                data: { id: _id },
                store: self.$store
              }).then(res => {
                self.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  let _key = self.keyCur;
                  self.keyCur = { id: null };
                  self.loadKey(_key);
                }
              });
            }
          }
        }
      );
    },
    cascaderOnChange(value, selectedData) {
      // console.log(value, selectedData);
      this.locTypeModel.parentId =
        value[value.length - 1] != undefined ? value[value.length - 1] : null;
      //console.log('this.locTypeModel.parentId', this.locTypeModel.parentId);
    },
    saveLocType() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Type/PostType" },
        data: { model: this.locTypeModel },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.cascaderSelected = [];
          let _key = this.keyCur;
          this.keyCur = { id: null };
          this.loadKey(_key);
        }
      });
    },
    treeItemClick(e) {
      // console.log('treeItemClick', e)
      //console.log('treeItemClick', e, this.locTypeModel.id);
      // this.showAddEditMdl(2, e.id);
      this.showAddEditMdl(2, e.value);

      //if(e.id!=this.locTypeModel.id){
        //console.log("is yalgaatai")
        //this.locTypeModel.id = e.id;
        this.initField(this.locTypeModel.id, 0);
      //}
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Ltdb/GetFields" },
        params: { locTypeId: e.value },
        // params: { locTypeId: e.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('GetFields=> ', res);
          this.fields = res.data.fields;
          //this.fieldModel.id = e.id;
        }
      });
    },
    saveField() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //console.log('PostField n header n', this.fieldModel);
      request({
        api: { method: "POST", url: "Ltdb/PostField" },
        data: { model: this.fieldModel },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.fieldModel.property.type = null;
          this.fieldModel.property.struct = null;

          this.treeItemClick({ id: this.locTypeModel.id });
          //console.log('PostField=> ', res);
        }
      });
    },
    componentOnChange(e) {
      if (e == 4) {
        this.fieldModel.property.struct = "int";
      } else if (e == 5) {
        this.fieldModel.property.struct = "date";
      }
    },
    postValue() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Ltdb/PostValue" },
        data: { model: this.valueModel },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.treeItemClick({ id: this.locTypeModel.id });
          this.initValue({ property: { id: 0 } });
        }
      });
    }
  }
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
